export const ANALYTICS = 'analytics';
export const  GET_ANALYTICS_REPORT_LIST = `${ANALYTICS}/getAnalyticsReportListAction`;
export const GET_ANALYTICS_ANALYTICS_REPORT = `${ANALYTICS}/getAnalyticsAnalyticsReportAction`;
